export interface IVendorRepresentationRequest {
  region: string[];
  country: string[];
  majorLineOfBusiness: string[];
  primaryVendorCategory: string[];
  vendorServiceCategory: string[];
  vendorPanelDescription: string;
 }
